<script lang="ts" setup>
import { ref, watch } from "vue";

const model = defineModel<string>({ default: "" });

withDefaults(
  defineProps<{
    flat?: boolean;
    hideBubble?: boolean;
  }>(),
  {
    flat: true,
    hideBubble: true,
  },
);

const innerValue = ref(model.value);
let lastEmitted = model.value;

watch(model, (value) => {
  if (value !== lastEmitted) {
    innerValue.value = value;
  }
});

function onUpdate(value: string | object | unknown) {
  if (typeof value === "string") {
    lastEmitted = value;
    model.value = value;
  }
}
</script>

<template>
  <VuetifyTiptap
    :flat="flat"
    :hide-bubble="hideBubble"
    :model-value="innerValue"
    v-bind="$attrs"
    @update:model-value="onUpdate"
  >
    <template v-for="(_, name) in $slots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps ?? {}" />
    </template>
  </VuetifyTiptap>
</template>
